import dbg_logo from "branchAndBrandSpecific/utils/brandVariables/assets/dbg/dbg_accent_short.svg";
import dbg_logo_white from "branchAndBrandSpecific/utils/brandVariables/assets/dbg/dbg_white_short.svg";
import dbg_logo_small from "branchAndBrandSpecific/utils/brandVariables/assets/dbg/dbg_appicon.webp";
import newsCover from "@/assets/cover/news_dbg.webp";

export const DBG_brandVariables = {
  siteTitle: "Danmarks Bedste Gamer",
  siteIcon: dbg_logo_small,
  name: "Danmarks Bedste Gamer",
  name_small: "DBG",
  logos: {
    large: dbg_logo,
    white: dbg_logo_white,
    small: dbg_logo,
    medium: null,
    alt_text: "Danmarks Bedste Gamer logo",
    profile: null,
  },
  cover: {
    news: newsCover,
  },
  tenantId: "danmarksbedstegamer-ls5y4",
  brandTheme: "dbg", // Theme of the brand
  site: "app.danmarksbedstegamer.dk", // Live url of site
  authMethod: "email", // Only needed for events, gives user set options to manualy sign up, options are:  email | phone
  defaultCountryCode: "DK", // Only needed for retail platforms | For initial phone number | Changes all auth methods`
  defaultLanguage: "da",
  brandStoreExtension: "", // Only needed for retail platforms | Extension used for email
  brandValue: "DBG", // Only needed for retail platforms | Brand value needed for BE related functions
  brandIntials: "", // gets added after the username, to drasticaly descrease chance of duplicate usernames across different apps | Only needed for event platforms
  defaultNavigateUrl: "/",
  eventHasAutoQrSignup: false,
  hasSubClients: false,
  subClientsForOverviews: null, // string[] of clients used to fetch multiple types of clients for overview pages
  autoJoinChallenge: false,
  hasFeature: {
    notifications: false,
    themes: false,
    connections: false,
    achievements: false,
    messages: false,
    teams: false,
    news: true,
    challenges: true,
    singleChallenge: true,
    preferences: false,
    friends: false,
    zones: false,
    feed: true,
    posts: false,
    winners: false, // !! Also add the data variables for this feature in brandVariables.tsx !!
    schedule: false, // !! Also add the data variables for this feature in brandVariables.tsx !!
    qrSignUp: false,
    manualSubmissions: false,
    landing: true,
    login: true,
    haslanguagePicker: true,
    getstarted: false,
    hero: false,
    search: false,
    routes: false,
    dailytasks: false,
    games: false,
    treasure_hunt: false,
    activities: false,
    changePassword: true,
    feedback: true,
    events: false,
  },
  hasAuth: {
    steam: false,
    bnet: false,
    quickSignUp: false,
    google: false,
    discord: true,
    twitch: false,
  },
  layout: {
    challenge: "default",
  },
  event: {
    forcedCredentialPopup: "email",
    eventCode: "", // Only needed for event platforms
    collectionForSubmissions: "",
    documentForSubmissions: "",
    isEvent: false,
    spacecoins_redirect: true,
  },
  hasCreate: {
    challenges: false,
    news: false,
  },
};
